import { Injectable } from '@angular/core';


@Injectable()
export class PaginationConfig {
  size = 10;
  pageSizeOptions = [5, 10, 25, 100];

}
